import React from "react";

const ServicePerformanceTable = ({ servicePerformance = [] }) => {
  const displayPerformance = (servicePerformance && servicePerformance.length > 0)
    ? servicePerformance
    : [
      { name: "Text-to-Text (TTT)", requests: "0", tokens: "0", responseTime: "0ms", success: "0%" },
      { name: "Text-to-Speech (TTS)", requests: "0", tokens: "0", responseTime: "0ms", success: "0%" },
      { name: "Speech-to-Text (STT)", requests: "0", tokens: "0", responseTime: "0ms", success: "0%" },
      { name: "Speech Translations (STS)", requests: "0", tokens: "0", responseTime: "0ms", success: "0%" },
    ];

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-4">Per-Service Performance (Last 14 Days)</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-gray-200 text-xs font-semibold text-gray-500">
              <th className="py-3 px-4">Service</th>
              <th className="py-3 px-4">Tokens</th>
              <th className="py-3 px-4">Avg Response Time</th>
              <th className="py-3 px-4">Success</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 text-sm">
            {displayPerformance.map((row, idx) => (
              <tr key={idx} className="hover:bg-gray-50/80 transition-colors">
                <td className="py-3.5 px-4 font-bold text-gray-900">{row.name}</td>
                <td className="py-3.5 px-4 text-gray-600">{row.tokens}</td>
                <td className="py-3.5 px-4 text-gray-600">{row.responseTime}</td>
                <td className="py-3.5 px-4 font-bold text-emerald-600">{row.success}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServicePerformanceTable;
